import Table from './table';
export type {
  TTableInitialState,
  TTableExtendedState,
  TableTypeWorkaround,
  TTableExtendedHeaderGroup,
} from './table.types';
export type { TableProps } from './table';

export default Table;
